
<template>
  <router-view />
</template>
<script>
import commonServices from './shared/commonServices';

export default {
  mixins: [commonServices],
  data() {
    return {
      inactivityCheckIntervalId: null
    }
  },
  methods: {
    updateActivity() {
      try {
        localStorage.setItem('lastActivity', String(Date.now()))
      } catch (e) {}
    },
    checkInactivity() {
      try {
        const last = Number(localStorage.getItem('lastActivity') || 0)
        const now = Date.now()
        const HoursMs = 60 * 60 * 1000
        if (last > 0 && now - last >= HoursMs) {
          localStorage.clear()
          this.$router.push({ name: 'login' })
        }
      } catch (e) {}
    }
  },
  mounted() {
    this.fetchAndApplyThemeColors();
    document.body.style.backgroundColor = 'var(--theme-bg-end)';
    document.body.style.fontFamily = '"Inter", "Segoe UI", system-ui, -apple-system, sans-serif';
    this.$store.dispatch('modules_options/fetchModules');
    // if a user is already logged in (localStorage set), restore persisted permissions into the store
    try {
      if (localStorage.userId && localStorage.userPermissions) {
        const perms = JSON.parse(localStorage.userPermissions || '[]');
        this.$store.commit('modules_options/SET_USER_PERMISSIONS', perms);
      }
      // Fetch latest permissions from server to ensure they are up to date
      if (localStorage.userId) {
        this.$store.dispatch('modules_options/fetchUserPermissions');
      }
    } catch (e) {
      console.error('Failed to restore user permissions from localStorage', e);
    }
    this.checkInactivity()
    const events = ['mousemove','keydown','click','touchstart']
    events.forEach(ev => document.addEventListener(ev, this.updateActivity, { passive: true }))
    this.updateActivity()
    this.inactivityCheckIntervalId = setInterval(this.checkInactivity, 60000)
  },
  beforeUnmount() {
    const events = ['mousemove','keydown','click','touchstart']
    events.forEach(ev => document.removeEventListener(ev, this.updateActivity))
    if (this.inactivityCheckIntervalId) {
      clearInterval(this.inactivityCheckIntervalId)
      this.inactivityCheckIntervalId = null
    }
  }
}

// window.onbeforeunload = function () {
//   localStorage.clear();
// };

</script>
